import { ReactNode } from "react";
import { ArtistEditBalance } from "./ArtistEditBalance";
import { ArtistEditOverview } from "./ArtistEditOverview";
import { ArtistEditSubscription } from "./ArtistEditSubscription";

export function artistEditTabPath({
  artistId,
  tab,
}: {
  artistId: string;
  tab: string;
}): string {
  return `/admin/artists/${artistId}/${tab}`;
}

export function getCurrentArtistEditTab(pathname: string): string {
  if (pathname.includes("/subscription")) return "subscription";
  if (pathname.includes("/balance")) return "balance";
  return "overview";
}

export function getArtistEditTabs({
  artistId,
}: {
  artistId: string;
}): Array<{ value: string; label: string; content: ReactNode }> {
  return [
    {
      value: "overview",
      label: "Overview",
      content: <ArtistEditOverview artistId={artistId} />,
    },
    {
      value: "balance",
      label: "Balance",
      content: <ArtistEditBalance artistId={artistId} />,
    },
    {
      value: "subscription",
      label: "Subscription",
      content: <ArtistEditSubscription artistId={artistId} />,
    },
  ];
}
